const HERO_URL_PARAM = "hero";

/**
 * Hero banner visibility on checkout.
 *
 * One checkout serves both entry points, so `?hero=` wins whenever it is present: advertorial
 * links pass `hero=1` (banner shown, even when the ACF "Show Section" toggle is off), product
 * page links pass `hero=0` (banner hidden, its image already shown on the product page).
 * Without the param the ACF toggle decides, so links that predate this stay as they are.
 */
const showProductHero = () => {
  const heroParam = new URL(window.location.href).searchParams.get(HERO_URL_PARAM);

  if (heroParam === "1") {
    return true;
  }

  if (heroParam === "0") {
    return false;
  }

  return Boolean(window?.post_template?.checkout_v4_product_hero?.checkout_v4_product_hero_show);
};

export default showProductHero;
